
export const typeMensager = {
    error: "error",
    success: "success",
    warning: "warning"
}
export const AltrarSenha = "Adicione seu email para cadastrar uma nova senha.";
export const UrlLogin = "Usuario/Login";
export const UrlDeslogar = "Usuario/Deslogar";

